import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";


export default function ModalShell({
  visible,
  onHide,
  title = "Diálogo",

  width = "32rem",              
  style,                         
  className,                    
  contentClassName,            
  breakpoints,                   


  formId,                      
  okLabel = "Guardar",
  cancelLabel = "Cancelar",
  okLoading = false,
  okDisabled = false,
  onConfirm,
  footer,                        


  appendTo = typeof document !== "undefined" ? document.body : undefined,

  children
}) {
  const handleHide = (event) => {
    // PrimeReact selectors consume Escape before it reaches the dialog.
    if (okLoading || (event?.key === "Escape" && event.defaultPrevented)) return;
    onHide?.(event);
  };
  const defaultFooter = (
    <div style={{ display: "flex", justifyContent: "flex-end", gap: ".5rem" }}>
      <Button type="button" label={cancelLabel} text onClick={onHide} disabled={okLoading} />
      <Button
        {...(formId ? { type: "submit", form: formId } : { type: "button" })}
        label={okLabel}
        icon="pi pi-check"
        loading={okLoading}
        disabled={okDisabled || okLoading}
        onClick={formId ? undefined : (onConfirm || onHide)}
      />
    </div>
  );


  const mergedStyle = { width, ...style };

  return (
    <Dialog
      header={title}
      visible={visible}
      onHide={handleHide}
      modal
      draggable={false}
      resizable={false}
      blockScroll
      closeOnEscape={!okLoading}
      closable={!okLoading}
      pt={{ closeButton: { "aria-label": "Cerrar diálogo" } }}
      appendTo={appendTo}
      className={`teamassess-dialog ${className || ""}`}
      contentClassName={contentClassName}
      style={mergedStyle}
      breakpoints={breakpoints}
      footer={footer !== undefined ? footer : defaultFooter}
    >
      {children}
    </Dialog>
  );
}
